export default {
  common: {
    loading: 'Loading...',
    loading_short: '...',
    saving: 'Saving...',
    saving_short: '...',
    save: 'Save',
    add: 'Add',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    close: 'Close',
    back: 'Back',
    refresh: 'Refresh',
    update: 'Update',
    all: 'All',
    name: 'Name',
    description: 'Description',
    link: 'Link',
    date: 'Date',
    month: 'Month',
    slug: 'slug',
    error: 'Error',
    select_placeholder: 'Select...',
    url_placeholder: 'https://...',
    copy: 'Copy',
    copy_link: 'Copy link',
    copied: 'Copied',
    copy_failed: 'Could not copy',
    edit_title: 'Edit',
    save_error: 'Save failed',
    delete_error: 'Delete failed',
    details: 'Details',
    hide: 'Hide',
    generating: '{label}...',
    files_count: '{count} file(s) · {date}',
  },

  nav: {
    brand: 'SMM Admin',
    home: 'Home',
    smm: 'SMM',
    logout: 'Log out',
  },

  auth: {
    brand: 'Vue Laravel SPA',
    login: {
      email: 'Email',
      password: 'Password',
      remember_me: 'Remember me',
      forgot_password: 'Forgot your password?',
      submit: 'Log in',
      submitting: 'Signing in…',
      show_password: 'Show',
      hide_password: 'Hide',
      no_account: "Don't have an account yet?",
      sign_up: 'Sign up now',
    },
    register: {
      name: 'Name',
      email: 'Email',
      password: 'Password',
      password_confirmation: 'Repeat Password',
      submit: 'Register',
    },
    forgot_password: {
      email: 'Email',
      submit: 'Send Password-Reset E-Mail',
    },
    reset_password: {
      email: 'Email',
      password: 'Password',
      password_confirmation: 'Password Confirmation',
      submit: 'Reset Password',
    },
    confirm_password: {
      title: 'Confirm your Password',
      description:
        'You need to confirm your password in order to perform the requested action. After confirmation you can retry your action.',
      password: 'Password',
      submit: 'Confirm',
    },
    verify_email: {
      title: 'Verify Email Address',
      description:
        "Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you? If you didn't receive the email, we will gladly send you another.",
      resend: 'Resend Verification Email',
    },
    two_factor_challenge: {
      code: 'TwoFactor Code',
      submit: 'Log in',
    },
  },

  home: {
    welcome: 'Welcome to your Vue SPA powered by Laravel.',
  },

  errors: {
    not_found: 'Page Not found',
    auth_required: 'Please sign in',
  },

  user: {
    profile: {
      section_title: 'Profile',
      section_description: "Update your account's profile information and email address.",
      name: 'Name',
      email: 'Email',
    },
    password: {
      section_title: 'Password',
      section_description: 'Ensure your account is using a long, random password to stay secure.',
      current: 'Current Password',
      new: 'New Password',
      confirmation: 'Password Confirmation',
    },
    two_factor: {
      section_title: 'Two Factor Authentication',
      section_description: 'Add additional security to your account using two factor authentication.',
      enabled: 'You have enabled two factor authentication.',
      disabled: 'You have not enabled two factor authentication.',
      description:
        "When two factor authentication is enabled, you will be prompted for a secure, random token during authentication. You may retrieve this token from your phone's Google Authenticator application.",
      setup_key: 'Setup Key:',
      activate_instruction:
        'To activate Two-Factor-Authentication scan the QR-Code and enter your first TOTP-Code here.',
      code: 'Two Factor Code',
      activate_submit: 'Activate 2FA',
      activate: 'Activate',
      show_recovery_codes: 'Show Recovery-Codes',
      reset_recovery_codes: 'Reset Recovery-Codes',
      deactivate: 'Deactivate',
      deactivate_confirm: 'Are you sure you want to deactivate Two Factor Authentication?',
    },
  },

  smm: {
    nav: {
      networks: 'Social networks',
      schedule: 'Schedule',
      content: 'Content',
      kanban: 'Kanban',
      board: 'Board',
      settings: 'Settings',
      marketing_plans: 'Marketing',
      today: 'Today',
      stats: 'Stats',
    },
    common: {
      social_network: 'Social network',
    },
    prompt_kind: {
      schedule: 'Schedule',
      post_image: 'Post image',
      post_video: 'Post video',
      custom: 'Other',
    },
    status: {
      backlog: 'Backlog',
      todo: 'To do',
      in_progress: 'In progress',
      review: 'Review',
      done: 'Done',
    },
    content_kind: {
      video: 'YouTube video',
      masterclass: 'Etsy masterclass',
      content: 'Content',
    },
    networks: {
      title: 'Social networks',
      subtitle: 'SMM channels: prompts, schedule, content',
      add: 'Add social network',
      empty: 'No social networks. Add Pinterest or another platform.',
      badge_api: 'API',
      badge_inactive: 'off',
      stats: 'Prompts: {prompts} · Tasks: {tasks} · Ideas: {ideas}',
      new_title: 'New social network',
      slug: 'Slug (URL)',
      slug_placeholder: 'pinterest',
      profile_url: 'Profile link',
      profile_url_placeholder: 'https://...',
      username: 'Username',
      password_hint: 'Password reminder',
      password_hint_help: 'Not the real password — a hint so you remember it.',
      followers_count: 'Followers',
      followers_label: '{count} followers',
      has_api: 'Has API (integration stub)',
      is_active: 'Active',
      base_prompt: 'Base prompt',
      base_prompt_placeholder: 'Main instructions for this social network (tone, audience, rules)…',
      base_prompt_help: 'Prepended to AI generation for this network. Overrides the old “prefix” template if filled.',
      base_prompt_ready: 'Base prompt is set',
      shop: 'Sales channel',
      shop_none: 'Not selected',
      platform: 'Network type',
      platform_none: 'Not selected',
      platforms: {
        instagram: 'Instagram',
        pinterest: 'Pinterest',
        etsy: 'Etsy',
        youtube: 'YouTube',
        threads: 'Threads',
        facebook: 'Facebook',
      },
      load_error: 'Failed to load social networks',
      delete_confirm: 'Delete «{name}»?',
    },
    ideas: {
      open: 'Ideas',
      title: 'Ideas',
      subtitle: 'Creative ideas for this channel — used later when generating the schedule.',
      count: '{n} idea(s)',
      add: 'Add idea',
      empty: 'No ideas yet. Add the first one.',
      select_or_add: 'Select an idea on the left or click “Add idea”.',
      new_title: 'New idea',
      edit_title: 'Edit idea',
      untitled: 'Untitled idea',
      field_title: 'Title',
      field_title_placeholder: 'Short label (optional)',
      field_body: 'Description',
      field_body_placeholder: 'What is the idea? Tone, hook, angle…',
      images: 'Images',
      paste_hint: 'Paste an image here (Ctrl+V) or drop files',
      paste_manual_hint: 'Copy an image, click the paste zone and press Ctrl+V',
      files: 'Attachments',
      attach_files: 'Attach files',
      files_empty: 'No non-image files yet.',
      files_count: '{n} file(s)',
      saved: 'saved',
      delete_confirm: 'Delete this idea and its files?',
    },
    network_detail: {
      back: '← Social networks',
      prompts_title: 'Prompts',
      add_prompt: 'Add prompt',
      prompts_empty: 'No prompts. Add "Post schedule", "Post image generation", etc.',
      prefix_hint:
        'Automatically prepended to any AI prompt. Not selectable manually.',
      schema_summary: 'JSON response schema',
      generate_schedule: 'Generate schedule',
      edit_prompt: 'Edit prompt',
      new_prompt: 'New prompt',
      prompt_body_placeholder: 'Prompt text + JSON instruction',
      schema_label: 'JSON response schema (object)',
      schema_placeholder: '{"caption": "string", "hashtags": []}',
      invalid_schema: 'Invalid JSON in schema',
      delete_prompt_confirm: 'Delete prompt «{name}»?',
      schedule_created: 'Schedule created: {days} days, {pins} pins. Open "Schedule" (Month view).',
      schedule_created_at: 'Created: {when}',
      overwrite_confirm: 'Overwrite the schedule with the new result?',
      generate_error: 'Generation failed',
    },
    schedule: {
      title: 'Schedule',
      view_mode: 'View',
      mode_month: 'Month',
      mode_day: 'Single day',
      month_description:
        'Month overview: each day may have several pin variants. Click a pin to generate content.',
      day_description: 'Slots for {date}',
      stats: 'Days: {days} · Pins: {pins}',
      empty_day: 'No entries for this day.',
      empty_month: 'No days for this month.',
      empty_hint: 'Generate a schedule in the social network card.',
      pin: 'no pins | {n} pin | {n} pins',
      slot_error: 'Could not identify schedule slot',
      open_error: 'Could not open slot. Check that DB migration was run (php artisan migrate).',
      resolve_error: 'Could not match content',
      max_images: 'You can select up to 5 images for the prompt.',
      min_images: 'Select at least one image.',
      files_update_error: 'Could not update file selection',
      pin_published: 'Pin published',
      publish_error: 'Publish failed',
    },
    schedule_modal: {
      tab_content: 'Content',
      tab_logs: 'Logs',
      matched_content: 'Matched content',
      resolving: 'Matching...',
      rematch: 'Match again',
      searching: 'Searching library for a match...',
      match_fuzzy: 'fuzzy match',
      match_exact: 'exact match',
      library_description: 'Library description (sent to prompt)',
      video_label: 'Video · {name}',
      no_images: 'No images for this content entry',
      photo_selection_hint: 'Photos for prompt (up to 5): {n}/5 — click to toggle',
      video_hint: 'Video (not sent as reference image):',
      no_match:
        'No matching content found. Add materials on the Content page or click "Match again".',
      generated_pin: 'Generated pin',
      ai_json: 'AI response (JSON)',
      published: 'Published to Pinterest · {date}',
      prompt: 'Prompt',
      extra_photos: 'Extra photos for prompt',
      extra_photos_hint: 'Up to 5 images total including library selection',
      notes: 'Notes',
      pinterest: 'Pinterest',
      link_placeholder: 'Link to product or video',
      default_board: 'Default board',
      publishing: 'Publishing...',
      publish: 'Publish to Pinterest',
      generate: 'Generate content',
    },
    kanban: {
      click_hint: 'Click → next status',
    },
    board: {
      project: 'Project',
      create_ticket: 'New ticket',
      no_projects: 'No projects yet.',
      go_settings: 'Configure in Settings',
      ticket_title: 'Title',
      status: 'Status',
      type: 'Type',
      priority: 'Priority',
      priority_low: 'Low',
      priority_medium: 'Medium',
      priority_high: 'High',
      priority_urgent: 'Urgent',
      due_date: 'Due date',
      due_short: 'Due',
      description: 'Description',
      description_placeholder: 'What needs to be done…',
      sections: 'Sections',
      sections_empty: 'No sections. Add section templates in Settings → Board.',
      section_placeholder: 'Write here…',
      attachments: 'Attachments',
      attachments_empty: 'No files yet',
      attachments_drop_hint: 'Drop files here or paste an image (Ctrl+V)',
      attachments_paste_hint: 'Click the drop zone and press Ctrl+V, or allow clipboard access',
      upload: 'Upload',
      comments: 'Comments',
      comments_empty: 'No comments yet',
      comment_placeholder: 'Add a comment…',
      comment_add: 'Send',
      anonymous: 'User',
      delete_confirm: 'Delete this ticket?',
      links: 'Links',
      links_empty: 'No links yet',
      link_add: 'Add',
      link_title_placeholder: 'Label (optional)',
      link_url_placeholder: 'https://… or any URL',
      linked_tickets: 'Linked tickets',
      linked_tickets_empty: 'No linked tickets',
      linked_search_placeholder: 'Search ticket by title or #id…',
    },
    media: {
      title: 'Content',
      subtitle: 'Material library for Pinterest, Instagram and other platforms',
      tab_published: 'Published',
      tab_generated: 'Generated',
      youtube_import: 'YouTube channel',
      etsy_import: 'Etsy product',
      add: 'Add content',
      empty: 'No media. Add the first item with images or video.',
      empty_shop: 'No content for this shop yet.',
      mp4_badge: 'MP4',
      play: 'Play',
      video: 'Video',
      edit_title: 'Edit media',
      new_title: 'New media content',
      files: 'Files',
      short_description: 'Short description',
      load_error: 'Failed to load media',
      files_required: 'Add at least one file (image or MP4)',
      delete_file_confirm: 'Delete this file?',
      delete_confirm: 'Delete «{title}» and all files?',
      shop: 'Shop',
      shop_required: 'Select a shop',
      shops_missing: 'No shops found. Run migration on the server.',
      filter_all: 'All',
      filter_unknown: 'Unknown',
      media_count: '{n} media',
      tags_count: '{n} tags',
      open_product: 'Open product',
      no_shop: 'No shop',
      select_all: 'Select all',
      deselect_all: 'Clear selection',
      with_selected: 'With selected',
      batch_activate: 'Activate',
      batch_deactivate: 'Deactivate',
      batch_delete: 'Delete',
      batch_assign_shop: 'Assign shop',
      batch_assign_shop_prompt: 'Select shop',
      batch_none: 'Select at least one item',
      batch_delete_confirm: 'Delete {n} selected item(s)?',
      inactive_badge: 'Off',
      loading_more: 'Loading more...',
      tags: 'Tags',
      tags_empty: 'No tags',
      tags_placeholder: 'Tag name or pick from list',
      tag_add: 'Add',
      tag_create_error: 'Could not create tag',
      list_stats: 'Selected: {selected} · Shown: {shown} of {total}',
      search_placeholder: 'Search title, description or tags…',
      search_button: 'Search',
      tags_generate: 'Generate tags',
      tags_generate_quick: 'Generate and attach tags',
      tags_generating: 'Generating…',
      tags_generate_error: 'Could not generate tags',
      tags_generate_empty: 'No new tags to suggest',
      tags_preview_title: 'Suggested tags',
      tags_preview_hint: 'Uncheck any you do not want, then apply or cancel.',
      tags_preview_apply: 'Apply selected',
      tags_preview_cancel: 'Cancel',
      tab_main: 'Main',
      tab_media: 'Media',
      is_active: 'Active',
      preview_empty: 'No media yet',
      files_drag_hint: 'Drag tiles to change order. The first file is used as preview.',
      files_reorder_error: 'Could not save media order',
      batch_save_images: 'Save images to device',
      save_images_selected: 'Save to gallery ({n})',
      save_images_busy: 'Preparing…',
      save_images_none: 'No images to save',
      save_images_error: 'Could not save images. On iPhone use Share → Save Image.',
    },
    upload: {
      tile_title: 'Choose file, drag & drop or Ctrl+V',
      paste_clipboard: 'Paste from clipboard',
      add: 'Add',
      ctrl_v_hint: 'Ctrl+V',
      play: 'Play',
      select_files: 'Choose from computer',
      paste_zone_title: 'Image paste zone',
      paste_zone_instruction: 'Copy an image, click here and press Ctrl+V',
      paste_ready: 'Ready — press Ctrl+V',
      convert_png_error: 'Could not convert «{name}» to PNG',
      browser_open_error: 'Browser cannot open «{name}». Save as JPEG or PNG.',
      mp4_only: '«{name}»: only MP4 is supported',
      image_or_mp4: '«{name}»: image or MP4 required',
      add_error: 'Failed to add file',
      paste_hint_compact: 'Copy an image and press Ctrl+V on the «+» tile',
      paste_hint_full: 'Copy an image, then click the zone above and press Ctrl+V',
    },
    ai_logs: {
      title: 'AI logs',
      empty: 'No requests yet',
      type_schedule: 'Schedule',
      type_post_content: 'Post content',
      prefix_applied: 'Prefix (slug prefix): applied',
      catalog_count: 'Content catalog: {n} entries',
      provider: 'Provider: {provider}',
      references: 'References: {files} (in API: {count})',
      references_api: 'References in API: {n}',
      schedule_stats: 'Days: {days} · pins: {pins} (in JSON: {items})',
      prompt_summary: 'Prompt (request)',
      raw_response: 'Raw response',
      parsed_json: 'Parsed JSON',
    },
    pinterest: {
      title: 'Pinterest API',
      env_missing: 'Add PINTEREST_CLIENT_ID and PINTEREST_CLIENT_SECRET to .env',
      connected: 'Connected: @{username}',
      not_connected: 'Not connected — OAuth required',
      disconnect: 'Disconnect',
      connect: 'Connect Pinterest',
      default_board: 'Default board',
      select_board: 'Select board...',
      redirect_uri: 'Redirect URI in Pinterest: {uri}',
      connect_error: 'Connection failed',
      disconnect_confirm: 'Disconnect Pinterest?',
      board_saved: 'Board saved',
      connected_success: 'Pinterest connected successfully',
    },
    youtube: {
      title: 'Import videos from YouTube',
      description:
        'Each video is saved as a separate content entry (title, link, description, thumbnail).',
      tab_channel: 'Channel',
      tab_urls: 'Video URLs',
      channel_url: 'YouTube channel URL',
      channel_placeholder: 'https://www.youtube.com/@your-channel',
      channel_hint:
        'Supports @handle, /channel/UC…, /c/… and /user/…. With API key all videos load; without — last ~15 via RSS.',
      urls_label: 'Video URLs (one per line)',
      urls_placeholder: 'https://www.youtube.com/watch?v=...\nhttps://youtu.be/...',
      urls_hint:
        'Alternative if channel import is unavailable. Descriptions are fetched from video pages.',
      load_list: 'Load list',
      channel_preview: 'Channel: {title} · {n} videos',
      select_all: 'Select all ({selected}/{total})',
      no_description: 'No description',
      no_videos: 'No videos found.',
      import: 'Import ({n})',
      api_key_hint: 'Try the "Video URLs" tab or add YOUTUBE_API_KEY to .env',
      select_required: 'Select at least one video',
    },
    etsy: {
      title: 'Add Etsy product',
      tab_url: 'By URL',
      tab_html: 'Paste HTML',
      url_label: 'Etsy product URL',
      url_placeholder: 'https://www.etsy.com/listing/123456789/...',
      html_label: 'Page HTML',
      html_hint:
        'Open product on Etsy → Ctrl+U (view source) → Ctrl+A → Ctrl+C → paste here. Use if server gets HTTP 403.',
      html_placeholder: '<!DOCTYPE html>...',
      parse: 'Parse',
      images_count: 'Images ({n})',
      videos_count: 'Videos ({n})',
      image_alt: 'Image {n}',
      api_key_hint: 'Switch to "Paste HTML" or add ETSY_API_KEY to .env',
      no_images: 'No images to save',
    },
    settings: {
      menu_channels: 'Sales channels',
      menu_prompts: 'Prompts',
      channels_title: 'Sales channels',
      channels_subtitle: 'Shops and channels used in content filters',
      channels_empty: 'No channels yet. Add the first one.',
      channel_add: 'Add channel',
      channel_select: 'Select a channel on the left',
      channel_delete_confirm: 'Delete channel «{name}»?',
      slug: 'System slug',
      color: 'Color',
      homepage_url: 'Homepage URL',
      base_prompt: 'Base prompt',
      base_prompt_placeholder: 'Short description of the sales channel for AI and publishing…',
      media: 'Media files',
      media_hint: 'Drag to reorder. Same as content media.',
      is_active: 'Active',
      inactive: 'off',
      reorder_error: 'Could not save media order',
      prompts_title: 'System prompts',
      prompts_subtitle: 'Global prompts by type. Cannot be deleted — only edited.',
      prompts_empty: 'No prompts yet.',
      prompt_select: 'Select a prompt on the left',
      prompt_slug: 'Type (slug)',
      prompt_slug_locked: 'Unique type. Cannot be changed or deleted.',
      prompt_description: 'Description',
      prompt_body: 'Prompt text',
      prompt_body_placeholder: 'Text used during generation…',
      menu_campaigns: 'Campaigns',
      campaigns_title: 'Campaigns',
      campaigns_subtitle: 'Seasonal and thematic events: Back to school, Christmas, etc.',
      campaigns_empty: 'No campaigns yet. Add the first one.',
      campaign_add: 'Add campaign',
      campaign_select: 'Select a campaign on the left',
      campaign_delete_confirm: 'Delete campaign «{name}»?',
      campaign_starts_on: 'Start date',
      campaign_ends_on: 'End date',
      campaign_ends_on_optional: 'Optional',
      campaign_description: 'Event description',
      campaign_description_placeholder: 'What the event is about and what themes to emphasize in content…',
      campaign_priority: 'Priority (1–10)',
      menu_platforms: 'Platforms',
      platforms_title: 'Platforms',
      platforms_subtitle: 'Social platforms and their AI output schemas (metadata / content / platform_specific).',
      platforms_empty: 'No platforms yet. Add the first one.',
      platform_add: 'Add platform',
      platform_select: 'Select a platform on the left',
      platform_delete_confirm: 'Delete platform «{name}»?',
      platform_slug: 'Slug',
      platform_sort_order: 'Sort order',
      platform_output_schema: 'Output schema (JSON)',
      platform_output_schema_help: 'JSON Schema used by Generate Content for this platform.',
      platform_schema_invalid: 'Output schema must be valid JSON object.',
      menu_business: 'Business context',
      business_title: 'Business context',
      business_subtitle: 'Global company context for AI agents',
      business_company: 'Company',
      business_hours: 'Production hours per week',
      business_timezone: 'Timezone',
      business_language: 'Language',
      business_currency: 'Currency',
      business_notes: 'Notes',
      menu_board: 'Board',
      board_title: 'Board',
      board_subtitle: 'Projects, statuses (lanes), ticket types and section templates',
      board_tab_projects: 'Projects',
      board_tab_statuses: 'Statuses',
      board_tab_types: 'Types',
      board_tab_sections: 'Sections',
      board_empty: 'Nothing here yet. Add the first item.',
      board_add: 'Add',
      board_select: 'Select an item on the left',
      board_delete_confirm: 'Delete «{name}»?',
      board_is_done: 'Done status',
      board_field_type: 'Field type',
      sort_order: 'Sort order',
      menu_logs: 'Logs',
    },
    logs: {
      title: 'Logs',
      subtitle: 'AI and SMM logs with pagination. Full prompts open separately.',
      empty: 'No logs yet.',
      source_all: 'All sources',
      source_smm_ai: 'smm-ai.log',
      source_laravel: 'laravel (SMM)',
      source_prompts: 'Prompt files',
      level_all: 'All levels',
      search_placeholder: 'Search text…',
      search: 'Search',
      open: 'Open',
      show_context: 'Context',
      page_of: 'Page {page} / {pages} · {total} total',
    },
    marketing_plans: {
      title: 'Marketing plans',
      subtitle: 'Stage 1: monthly strategy via Marketing Director AI',
      empty: 'No plans yet. Generate the first one.',
      generate: 'Generate Marketing Plan',
      generate_schedule: 'Generate Schedule',
      open_today: 'Today workspace',
      tasks_count: 'tasks: {n}',
      platform_targets: 'Platform targets',
      priority_products: 'Priority products',
      schedule_confirm: 'Generate task queue for this plan? Planned tasks will be replaced. Generation runs week-by-week and may take a few minutes.',
      schedule_done: 'Tasks created: {n} (plan target ≈ {target}, AI returned {parsed})',
      status: {
        draft: 'draft',
        generating: 'generating',
        completed: 'completed',
        active: 'active',
        archived: 'archived',
      },
    },
    today: {
      title: "Today's Workspace",
      subtitle: 'Tasks for {date}',
      empty: 'No tasks for this day. Generate a Marketing Plan and Schedule first.',
      go_today: 'Today',
      prev_day: 'Previous day',
      next_day: 'Next day',
      no_product: 'No product',
      no_photo: 'No photo',
      product: 'Product',
      open_listing: 'Open listing',
      angle: 'Creative Goal / Concept',
      brief: 'Brief',
      selected_photos: 'Selected photos',
      pick_photos: 'Product photos',
      pick_photos_hint: 'Select 1–4 images to send to AI with Generate Content.',
      clear_selection: 'Clear',
      no_product_photos: 'This product has no photos yet. Upload them in Media.',
      max_photos: 'You can select up to {n} photos.',
      media_description: 'Media description',
      media_description_placeholder: 'What you filmed / showed…',
      generate_content: 'Generate Content',
      publish: 'Publish',
      publish_confirm: 'Mark this task as published?',
      generated: 'Generated content',
      envelope: {
        metadata: 'Metadata',
        data: 'Data',
        content: 'Content',
        platform_specific: 'Platform-specific',
      },
      status: {
        planned: 'planned',
        media_ready: 'media ready',
        content_generated: 'generated',
        published: 'published',
        skipped: 'skipped',
      },
    },
    stats: {
      title: 'Etsy sales stats',
      subtitle: 'Orders from Etsy emails. Each click pulls a small Gmail batch.',
      import_now: 'Load next batch',
      import_account: '{shop} — load batch',
      importing: 'Loading batch (~1 min)…',
      import_queued: 'Import started in background, waiting…',
      import_poll_timeout: 'Import still running or stuck. Check SSH/cron or storage/logs/etsy-import-bg.log',
      import_next_hint: 'Done. Offset {skip} — click again for the next {batch} emails.',
      import_result: 'Scanned {scanned}, imported {imported}, skipped {skipped}, failed {failed}.',
      import_result_account: '{shop}: scanned {scanned}, imported {imported}, skipped {skipped}, failed {failed}.',
      import_mailbox_total: 'Mailbox has {n} Etsy emails; database now has {db} orders.',
      mail_counts: 'In database: {db} orders. In mailbox (transaction@etsy.com): {mailbox}.',
      mail_counts_account: 'In database: {db} orders. Mailbox {shop}: {mailbox} emails.',
      mail_counts_db_only: 'In database: {db} orders.',
      all_shops: 'All shops',
      orders: 'Orders',
      revenue: 'Revenue',
      timezone: 'Timezone',
      period: 'Period',
      group_by: 'Group by',
      group_monthly: 'Monthly',
      group_all_time: 'All time',
      month_prev: 'Previous month',
      month_next: 'Next month',
      discounted_orders: 'Discounted',
      discounted_orders_short: 'Discounted',
      full_price_orders: 'Full price',
      avg_discount_pct: 'Avg discount (discounted only)',
      avg_discount_pct_short: 'Avg disc.',
      avg_discount_pct_hint: 'Among discounted orders only',
      discount_rate: 'Discount Rate',
      discount_rate_short: 'Disc. rate',
      discount_rate_hint: 'Σ discounts / Σ original price',
      discount_sum: 'Discount total',
      original_sum: 'Original',
      pricing_partial: 'Pricing known for {n} of {total} orders — click mail import again to backfill.',
      import_updated: 'Pricing updated: {n}.',
      weekday_col: 'Day',
      by_hour: 'Sales by hour',
      by_day: 'Orders by day',
      by_day_of_month: 'Orders by day of month (all time)',
      by_day_hint: 'Compare early vs late month — green 1–10, blue 11–20, violet 21–31',
      day_n: 'Day {n}',
      avg_orders_per_day: 'Average orders per day',
      avg_orders_overall: 'Whole period',
      avg_orders_days: '{n} days',
      month_phase: {
        start: 'Start of month',
        middle: 'Mid-month',
        end: 'End of month',
      },
      by_time_of_day: 'Time of day',
      by_weekday: 'Day of week',
      top_products: 'Top products',
      by_promo: 'Promo codes',
      promo_code: 'Promo code',
      promo_none: 'No promo code',
      promo_discount_pct: 'Discount %',
      product: 'Product',
      units: 'Units',
      name_variants: 'Merged {n} title variants',
      empty: 'No imported sales yet. Click “Load all from mailbox” to pull confirmation emails from Gmail.',
      mail_not_configured: 'Mailbox is not configured. Set DIY_ETSY_MAIL_USERNAME / DIY_ETSY_MAIL_PASSWORD (and BSS_… if needed) in .env (Gmail App Password).',
      mail_account_not_configured: 'Credentials for “{account}” are missing in .env.',
      mail_imap_missing: 'PHP IMAP extension is disabled. Enable extension=imap in php.ini and restart PHP.',
      mail_imap_blocked: 'Hosting blocks outbound IMAP (port 993 to Gmail). Import from the site will not work until 993 is opened — or run artisan import from your PC against the production DB.',
      import_empty_hint: 'No new Etsy confirmation emails to import (all already in DB, or none found).',
      import_done: 'Reached the end of the mailbox — no more transaction@etsy.com emails.',
      import_fast_done: 'Up to date: {db} in DB, {mailbox} in mailbox. No new mail.',
      import_fast_done_account: '{shop}: up to date ({db} in DB, {mailbox} in mailbox). No new mail.',
      import_zero_hint: 'No new orders in this batch (examined {examined}, already in DB {already}). Click again to continue further.',
      tod: {
        night: 'Night (0–5)',
        morning: 'Morning (6–11)',
        afternoon: 'Afternoon (12–17)',
        evening: 'Evening (18–23)',
      },
      weekday: {
        sun: 'Sunday',
        mon: 'Monday',
        tue: 'Tuesday',
        wed: 'Wednesday',
        thu: 'Thursday',
        fri: 'Friday',
        sat: 'Saturday',
      },
    },
    etsyGen: {
      panel_title: 'Generated listings',
      panel_subtitle: 'Generate Etsy listing data with AI.',
      panel_empty: 'Nothing generated yet. Click “New Etsy listing” to start.',
      new_listing: 'New Etsy listing',
      title: 'New Etsy listing',
      subtitle: 'Pick an Etsy shop, add photos and a short note — AI writes the title, description and tags.',
      network: 'Etsy shop (social network)',
      no_networks: 'No Etsy social networks found. Add one with platform “Etsy” in Networks.',
      photos: 'Photos (up to 5)',
      add_photo: 'Add',
      description: 'Short description',
      description_placeholder: 'What is this item? Materials, size, style, occasion…',
      generate: 'Generate data',
      generating: 'Generating…',
      result_hint: 'Listing data generated. Copy any field with the icon, then Save to keep it.',
      saved_hint: 'Saved. You can find this listing in the Generated tab.',
      save: 'Save listing',
      raw_json: 'Raw JSON',
      back_to_form: 'Back',
      list_untitled: 'Untitled listing',
      open: 'Open',
      delete_confirm: 'Delete this generated listing?',
    },
  },
}
